
export class Cashin {
    MaQuay: string;
  MaNV: string;
  MaCH: string;
  NgayGioNhap: string;
  GiaTri: number;
  }



// WEBPACK FOOTER //
// ./src/app/models/cash.model.ts